import jwt from 'jsonwebtoken';
import axios from 'axios';
import _ from 'lodash';
import UserProfile from '@/entities/UserProfile';

export default {
  async listAllUsers(shopToken) {
    const decodedToken = await jwt.decode(shopToken);
    const shopId = _.get(decodedToken, 'shop.id');
    const url = `${process.env.VUE_APP_MON_COMPTE_BACKEND_URL}/shops/${shopId}/users`;

    const res = await axios.get(url, { headers: { 'shop-token': shopToken } });
    const { data } = res.data;
    const users = data.map((user) => new UserProfile(user));

    return users;
  },
};
